import React from 'react';
import { useAuth } from '../../contexts/authContext';

/**
 * =========================================================================
 * SUPERVISOR SETTINGS PAGE
 * =========================================================================
 * 
 * Settings page for supervisor users.
 * Currently a placeholder - functionality to be implemented.
 * 
 * Access Control:
 * - Requires 'manage_settings' permission
 * =========================================================================
 */
const Settings = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="mt-2 text-gray-600">
            Manage your supervisor preferences and configurations
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <div className="text-center py-12">
              <svg 
                className="w-16 h-16 text-gray-400 mx-auto mb-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" 
                />
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
                />
              </svg>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Settings Coming Soon
              </h2>
              <p className="text-gray-600 mb-6">
                We're building comprehensive settings management for supervisors.
              </p>
              
              {/* Feature Preview */}
              <div className="max-w-md mx-auto">
                <h3 className="text-sm font-medium text-gray-900 mb-3">
                  Planned Features:
                </h3>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Profile management</li>
                  <li>• Notification preferences</li>
                  <li>• Team settings</li>
                  <li>• Security options</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* User Info Debug (remove in production) */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h3 className="text-sm font-medium text-yellow-800 mb-2">
              Debug Info (Development Only)
            </h3>
            <p className="text-xs text-yellow-700">
              User: {user?.name} | Permissions: {user?.permissions?.join(', ') || 'None'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings; 